// Token used by the local-dev-only demo session (/dev/demo-login). Never valid on the API.
export const DEMO_SESSION_TOKEN = 'local-demo-session';
